class LVReviewInvite extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.form = this.querySelector('form');
    this.status = this.querySelector('[data-status]');
    this.product = this.querySelector('[data-product]');
    this.reviewerName = this.querySelector('[name=reviewerName]');
    this.fileInput = this.querySelector('[name=photos]');
    this.previews = this.querySelector('[data-photo-previews]');
    this.body = this.querySelector('[name=body]');
    this.characterCount = this.querySelector('[data-character-count]');
    this.previewUrls = [];
    this.token = new URLSearchParams(location.search).get('token') || '';
    this.fileInput.addEventListener('change', () => this.renderPreviews());
    this.body.addEventListener('input', () => { this.characterCount.textContent = String(this.body.value.length); });
    this.querySelectorAll('[name=rating]').forEach((input) => input.addEventListener('change', () => this.renderRating(input.value)));
    if (!/^[A-Za-z0-9_-]{32,128}$/.test(this.token)) { this.fail('Yorum bağlantısı geçerli değil.'); return; }
    this.setBusy(true);
    try {
      const response = await fetch(`/apps/velora-reviews/api/invitations/${encodeURIComponent(this.token)}`, { headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Yorum bağlantısı açılamadı.');
      this.product.textContent = data.product.title;
      this.testMode = Boolean(data.testMode);
      this.toggleAttribute('data-test-mode', this.testMode);
      this.querySelector('[data-test-banner]').hidden = !this.testMode;
      if (this.testMode) this.querySelector('[data-submit]').firstChild.textContent = 'Test gönderimini tamamla ';
      if (data.reviewerName) {
        this.reviewerName.value = data.reviewerName;
        this.reviewerName.readOnly = true;
        this.reviewerName.setAttribute('aria-readonly', 'true');
      }
      this.form.hidden = false;
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.message(this.testMode ? 'Test bağlantısı hazır. Bu gönderim gerçek yorumlara eklenmez.' : 'Paylaşmak istediğin kadarını anlatman yeterli.');
    } catch (error) { this.fail(error.message); }
    finally { this.setBusy(false); }
  }

  disconnectedCallback() { this.clearPreviewUrls(); }

  renderRating(value) {
    const labels = ['', 'Beklentimin altında', 'Geliştirilebilir', 'İyi', 'Çok iyi', 'Harika'];
    this.querySelector('[data-rating-text]').textContent = labels[Number(value)] || 'Bir puan seç';
  }

  clearPreviewUrls() {
    this.previewUrls.forEach((url) => URL.revokeObjectURL(url));
    this.previewUrls = [];
  }

  renderPreviews() {
    this.clearPreviewUrls();
    this.previews.replaceChildren();
    const files = [...this.fileInput.files];
    if (files.length > 3) {
      this.fileInput.value = '';
      this.message('En fazla üç fotoğraf ekleyebilirsin.', true);
      return;
    }
    files.forEach((file, index) => {
      const figure = document.createElement('figure');
      const image = document.createElement('img');
      const caption = document.createElement('figcaption');
      const url = URL.createObjectURL(file);
      this.previewUrls.push(url);
      image.src = url;
      image.alt = `Seçilen fotoğraf ${index + 1}`;
      caption.textContent = `${index + 1}. fotoğraf`;
      figure.append(image, caption);
      this.previews.append(figure);
    });
    if (files.length) this.message(`${files.length} fotoğraf gönderime hazır.`);
  }

  async submit(event) {
    event.preventDefault();
    if (!this.form.reportValidity()) return;
    const files = this.fileInput.files;
    if (files.length > 3) { this.message('En fazla üç fotoğraf ekleyebilirsin.', true); return; }
    this.setBusy(true);
    this.message(this.testMode ? 'Test gönderimin kontrol ediliyor…' : 'Deneyimin güvenle gönderiliyor…');
    try {
      const response = await fetch(`/apps/velora-reviews/api/invitations/${encodeURIComponent(this.token)}/reviews`, { method: 'POST', body: new FormData(this.form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Yorum gönderilemedi.');
      this.form.hidden = true;
      this.clearPreviewUrls();
      this.previews.replaceChildren();
      this.classList.add('is-complete');
      this.product.textContent = this.testMode ? 'Test tamamlandı.' : 'Teşekkür ederiz.';
      this.message(data.message || 'Deneyimin alındı.');
    } catch (error) { this.message(error.message, true); }
    finally { this.setBusy(false); }
  }

  setBusy(value) { this.setAttribute('aria-busy', String(value)); }
  message(text, error = false) { this.status.dataset.error = String(error); this.status.textContent = text; }
  fail(text) { this.form.hidden = true; this.status.dataset.error = 'true'; this.status.textContent = text; }
}
if (!customElements.get('lv-review-invite')) customElements.define('lv-review-invite', LVReviewInvite);
